import '../sass/project.scss';

import { createApp } from 'vue';
import App from './components/App.vue';
import SearchSidebar from './components/SearchSidebar.vue';

const app = createApp(App);

app.mount('#app');
